<template>
  <article class="TermsText" id="tycos-text" v-html="tycos"></article>
</template>

<script>
export default {
  name: "TycosText",
  data() {
    return {
      tycos: "",
    };
  },
  async mounted() {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {

        this.tycos = xhttp.responseText
          .replace("{", "")
          .replace('"body":"', "")
          .replace('";', "")
          .replace('}', "")
          .replace("[[urlsitio]]", "https://cartablanca.com.mx/");

          
      }
    };
    xhttp.open(
      "GET",
      "https://api-mx-marketing.azure-api.net/sitios/tycos?type=2" +
        "?ref=" +
        Math.random() * 9999,
      true,
    );
    xhttp.setRequestHeader('campaign', 'general');
    xhttp.send();
  },
};
</script>

<style lang="css">
.TermsText{
  max-width: 960px;
  margin: 0 auto;
  color: white;
  font-size: 19px;
}

.TermsText h2, h3, p {
  margin: 0
}


.TermsText h2{
  font-size: 20px !important;
  font-weight: 900;
  line-height: 1.2em;
  margin-bottom: 1em;
}

.TermsText h3{
  letter-spacing: 0.1em
}
.TermsText p{
  margin-bottom: 1.5em
}
</style>
